import React, { useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { ArrowLeftIcon } from '@heroicons/react/24/outline';
import MealTypesManager from '../../components/MealTypesManager';
import MealAssignmentPanel from '../../components/MealAssignmentPanel';
import MealReportPanel from '../../components/MealReportPanel';

const MealsPage = () => {
  const { eventId } = useParams();
  const navigate = useNavigate();
  const [tab, setTab] = useState('types');

  const tabs = [
    { id: 'types', label: 'Meal Types' },
    { id: 'assign', label: 'Assign Coupons' },
    { id: 'report', label: 'Report' },
  ];

  return (
    <div className="p-6 max-w-5xl mx-auto space-y-6">
      <button
        onClick={() => navigate(-1)}
        className="inline-flex items-center gap-1 text-sm text-[#1672b9] hover:underline"
      >
        <ArrowLeftIcon className="w-4 h-4" />
        Back
      </button>

      <div>
        <h1 className="text-2xl font-bold text-gray-900">Meal Coupons</h1>
        <p className="text-sm text-gray-500 mt-1">
          Configure meals, assign to attendees, view reports
        </p>
      </div>

      <div className="border-b border-gray-200 flex gap-4">
        {tabs.map(t => (
          <button
            key={t.id}
            onClick={() => setTab(t.id)}
            className={`pb-3 px-1 text-sm font-medium border-b-2 transition-colors ${
              tab === t.id
                ? 'border-[#1672b9] text-[#1672b9]'
                : 'border-transparent text-gray-500 hover:text-gray-700'
            }`}
          >
            {t.label}
          </button>
        ))}
      </div>

      {tab === 'types' && <MealTypesManager eventId={eventId} />}
      {tab === 'assign' && <MealAssignmentPanel eventId={eventId} />}
      {tab === 'report' && <MealReportPanel eventId={eventId} />}
    </div>
  );
};

export default MealsPage;